import React from 'react'

export function renderTextWithLineBreaks(text) {
  return text.split('\n').reduce((children, textSegment, index) => {
    return [...children, index > 0 && <br />, textSegment]
  }, [])
}
